import { createContext as o, useContext as t } from "react";
const e = o("down"), r = () => t(e);
export {
  e as scrollDirectionContext,
  r as useScrollDirection
};
